export default __webpack_public_path__ + "static/media/Vazir-Black.1a73cdb9.eot";